__turbopack_context__.v({
  "container": "styles-module-scss-module__ZJMJNa__container",
  "descTitle": "styles-module-scss-module__ZJMJNa__descTitle",
  "description": "styles-module-scss-module__ZJMJNa__description",
  "moreCollapsed": "styles-module-scss-module__ZJMJNa__moreCollapsed",
  "paragraph": "styles-module-scss-module__ZJMJNa__paragraph",
  "readMore": "styles-module-scss-module__ZJMJNa__readMore",
  "wrapDesc": "styles-module-scss-module__ZJMJNa__wrapDesc",
});
